import { CallState, LoadingState } from '@lcs/shared/api';
import { createReducer, on } from '@ngrx/store';
import { onReset } from 'src/app/authentication/reset-reducer';

import { AccountVerification } from '../models/account-verification.model';
import * as AccountVerificationActions from './account-verification.actions';

export const accountVerificationFeatureKey = 'accountVerification';

export interface State {
   accountVerification: AccountVerification | null;
   callState: CallState;
   canAccountBeFinalized: boolean | null;
   submitState: CallState;
   verified: boolean | null;
}

export const initialState: State = {
   accountVerification: null,
   callState: LoadingState.Init,
   canAccountBeFinalized: null,
   submitState: LoadingState.Init,
   verified: null,
};

export const reducer = createReducer(
   initialState,
   onReset(initialState),
   on(AccountVerificationActions.pageEnter, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   }),

   on(AccountVerificationActions.activateAccountSuccess, (state, { accountVerification }) => {
      return {
         ...state,
         accountVerification,
         callState: LoadingState.Loading,
      };
   }),

   on(AccountVerificationActions.activateAccountFailure, (state, action) => {
      return {
         ...state,
         callState: { error: action },
      };
   }),

   on(AccountVerificationActions.retrievedCanAccountBeFinalizedSuccess, (state, { canAccountBeFinalized }) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
         canAccountBeFinalized,
      };
   }),

   on(AccountVerificationActions.savePassword, (state) => {
      return {
         ...state,
         submitState: LoadingState.Loading,
      };
   }),

   on(AccountVerificationActions.savePasswordSuccess, (state) => {
      return {
         ...state,
         submitState: LoadingState.Loaded,
      };
   }),

   on(AccountVerificationActions.savePasswordFailure, (state, action) => {
      return {
         ...state,
         submitState: { error: action },
      };
   })
);
